module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/44507755b21849685b8d585950b7a037.png";